import React from "react";

export default class DataNascitaInput extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			value: this.props.value,
		};
	}

	handleChange(event) {
		this.setState({ value: event.target.value });
		if (this.props.onChange) this.props.onChange(event.target.value);
	}

	componentDidUpdate(prevProps) {
		if (prevProps.value !== this.props.value) {
			this.setState({ value: this.props.value });
		}
	}

	render() {
		const passwordFlag = this.props.type !== undefined ? this.props.type === "password" : false;
		const readOnly = this.props.readOnly !== undefined && this.props.readOnly === true ? true : false;

		const inputStyle = {
			width: this.props.width !== undefined ? this.props.width : "300px",
			padding: "10px",
			fontFamily: "League Spartan, sans-serif",
		};

		return (
			<div style={mainClass}>
				<div style={name}>{this.props.name}</div>
				<input
					type="date"
					style={inputStyle}
					value={this.state.value !== undefined ? this.state.value : this.props.value}
					onChange={this.handleChange.bind(this)}
				></input>
			</div>
		);
	}
}

const mainClass = {
	padding: "5px",
};

const name = {};

const inputTextDisabled = {
	background: "#eeeeee",
	width: "300px",
	padding: "10px",
	fontFamily: "League Spartan, sans-serif",
};
